import { render } from "./BtnMetrika.vue?vue&type=template&id=7cd6e6e4"
import script from "./BtnMetrika.vue?vue&type=script&lang=js"
export * from "./BtnMetrika.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__